import { Ng2StateDeclaration } from '@uirouter/angular';
import { ProjectConfigurationComponent } from './containers/project-configuration/project-configuration.component';
import { TrainTypeConfigurationComponent } from './containers/train-type-configuration/train-type-configuration.component';

export const projectConfigurationsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'project-config',
    url: '/admin/project-configuration',
    component: ProjectConfigurationComponent
};

export const trainTypeConfigurationsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'train-type-config',
    url: '/admin/train-types-configuration',
    component: TrainTypeConfigurationComponent
};

export const CONFIGURATIONS_STATES = [
    projectConfigurationsState,
    trainTypeConfigurationsState
];
